module.exports = __webpack_public_path__ + "img/BannerColaboradoresyPymeMobile.459fc07c.png";